/* eslint-disable class-methods-use-this */
import axios from "axios";

import { deobfuscateSearchMapdots } from "./utils/obfuscate";

class MapdotService {
  async getAllMapdots() {
    const { data: mapdots } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots`,
      {},
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return mapdots;
  }

  async getStatusCounts() {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/status-counts`,
      {},
      { headers: { Authorization: `${localStorage.jwtToken}` } }
    );
    return data;
  }

  async getFilteredMapdots(
    filterString,
    mapdotsPerPage,
    currentPage,
    searchBy
  ) {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/filter`,
      {
        params: {
          filterString,
          mapdotsPerPage,
          currentPage,
          searchBy,
        },
      },
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return data;
  }

  async searchByName(q, category) {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/search-by-name`,
      { params: { q, category } }
    );
    return data;
  }

  async searchLocations(q) {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/search-locations`,
      { params: { q } }
    );
    return data;
  }

  async getPublicBailoDots(
    filterStringName
    // mapdotsPerPage,
    // currentPage,
  ) {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/public-filter`,
      {
        params: {
          filterStringName,
          // mapdotsPerPage,
          // currentPage,
        },
      },
      {}
    );
    return data;
  }

  async searchMapdots(day, category, filteredDate, ipCountryName) {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/search`,
      {
        params: {
          day,
          category,
          filteredDate,
          ipCountryName,
        },
      },
      {}
    );

    // Support legacy (plain array) and new ({ mapdots, meta }) BE response formats
    let rawArray;
    if (Array.isArray(data)) {
      rawArray = data;
    } else if (data && Array.isArray(data.mapdots)) {
      rawArray = data.mapdots;
    } else {
      rawArray = [];
    }
    const normalized = deobfuscateSearchMapdots(rawArray);

    if (Array.isArray(data)) return normalized;
    return { mapdots: normalized, meta: data.meta || null };
  }

  async searchMapdotsNoDay(category) {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/search-no-day`,
      {
        params: {
          category,
        },
      },
      {}
    );
    return data;
  }

  async getAllApprovedMapdots() {
    const { data: mapdots } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/approved`,
      {},
      {}
    );
    return mapdots;
  }

  async getAllPendingMapdots() {
    const { data: mapdots } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/pending`,
      {},
      {}
    );
    return mapdots;
  }

  async getAllRejectedMapdots() {
    const { data: mapdots } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/rejected`,
      {},
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return mapdots;
  }

  async getAllOnHoldMapdots() {
    const { data: mapdots } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/onhold`,
      {},
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return mapdots;
  }

  async getMapdotById(id) {
    const { data: mapdot } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${id}`,
      {},
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return mapdot;
  }

  async getMapdotBySlug(slug) {
    const { data: mapdot } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/by-slug/${encodeURIComponent(slug)}`,
      {},
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return mapdot;
  }

  async getMapdotByIdForEdit(id) {
    const { data: mapdot } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${id}/info-for-edit`,
      {},
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return mapdot;
  }

  async getMapdotLikesById(id) {
    const { data: mapdot } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${id}/likes`,
      {},
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return mapdot;
  }

  async uploadPhoto(mapdotId, imageUrl) {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${mapdotId}/upload-photo`,
      imageUrl,
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return data;
  }

  async addMapdot(
    title,
    description,
    timeStart, // open doors
    timeEnd, // close doors
    price,
    address,
    addressPlus,
    postalCode,
    city,
    country,
    categoryIdName,
    danceIdName,
    phoneNr,
    emailMapdot,
    frequency,
    website,
    instagram,
    facebook,
    day,
    musician,
    realOwner,
    activeSince,
    musicStyle,
    dateStart, // dia de semana. ej: Lunes, o lunes, miercoles, sabados, martes y jueves, etc
    dateEnd,
    dateOnce,
    offersPrivateLesson,
    offersOnlineLesson,
    classLevel,
    termsOfClass,
    publicName,
    schoolId,
    teacherId,
    belongsToRadioStation,
    belongsToPodcastPlatform,
    languageSpokenRadio,
    coordinatesLat,
    coordinatesLng,
    classSchedule,
    teacherSchedule,
    artistType,
    // language,
    // useReverseGeo,
    // userLatitude,
    // userLongitude,
  ) {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/add`,
      {
        title,
        description,
        // dateStart,
        // dateEnd,
        timeStart,
        timeEnd,
        price,
        address,
        addressPlus,
        postalCode,
        city,
        country,
        categoryIdName,
        danceIdName,
        phoneNr,
        emailMapdot,
        frequency,
        website,
        instagram,
        facebook,
        day,
        musician,
        realOwner,
        activeSince,
        musicStyle,
        dateStart,
        dateEnd,
        dateOnce,
        offersPrivateLesson,
        offersOnlineLesson,
        classLevel,
        termsOfClass,
        publicName,
        schoolId,
        teacherId,
        belongsToRadioStation,
        belongsToPodcastPlatform,
        languageSpokenRadio,
        artistType,
        coordinatesLatLong: coordinatesLat && coordinatesLng
          ? { lat: coordinatesLat, lng: coordinatesLng }
          : undefined,
        ...(Array.isArray(classSchedule) ? { classSchedule } : {}),
        ...(Array.isArray(teacherSchedule) ? { teacherSchedule } : {}),
        // language,
        // useReverseGeo,
        // userLatitude,
        // userLongitude,
      },
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return data;
  }

  async updateMapdot(
    title,
    description,
    timeStart,
    timeEnd,
    price,
    address,
    addressPlus,
    city,
    country,
    phoneNr,
    emailMapdot,
    frequency,
    website,
    instagram,
    facebook,
    day,
    musician,
    postalCode,
    mapdotId,
    activeSince,
    musicStyle,
    dateStart,
    dateEnd,
    dateOnce,
    offersPrivateLesson,
    offersOnlineLesson,
    classLevel,
    termsOfClass,
    publicName,
    schoolId,
    teacherId,
    belongsToRadioStation,
    belongsToPodcastPlatform,
    languageSpokenRadio,
    coordinatesLat,
    coordinatesLng,
    classSchedule,
    teacherSchedule,
    artistType,
  ) {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${mapdotId}/edit`,
      {
        title,
        description,
        // dateStart,
        // dateEnd,
        timeStart,
        timeEnd,
        price,
        address,
        addressPlus,
        city,
        country,
        // categoryIdName,
        // danceIdName,
        phoneNr,
        emailMapdot,
        frequency,
        website,
        instagram,
        facebook,
        day,
        musician,
        postalCode,
        activeSince,
        musicStyle,
        dateStart,
        dateEnd,
        dateOnce,
        offersPrivateLesson,
        offersOnlineLesson,
        classLevel,
        termsOfClass,
        publicName,
        schoolId,
        teacherId,
        belongsToRadioStation,
        belongsToPodcastPlatform,
        languageSpokenRadio,
        coordinatesLatLong: coordinatesLat && coordinatesLng
          ? { lat: coordinatesLat, lng: coordinatesLng }
          : undefined,
        artistType,
        ...(Array.isArray(classSchedule) ? { classSchedule } : {}),
        ...(Array.isArray(teacherSchedule) ? { teacherSchedule } : {}),
      },
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return data;
  }

  async likeMapdot(id) {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${id}/add-like`,
      {},
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return data;
  }

  async addComment(id, titleOfUser, checkStarsOfUser) {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${id}/add-comment`,
      {
        titleOfUser,
        checkStarsOfUser,
      },
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return data;
  }

  async putMapdotOnHold(mapdotId) {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${mapdotId}/onhold-mapdot`,
      {},
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return data;
  }

  async approveMapdot(mapdotId, mapdotLatLong) {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${mapdotId}/approve-mapdot`,
      {
        mapdotLatLong,
      },
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return data;
  }

  async findMapdotLatLong(mapdotId, address, city, country) {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${mapdotId}/findlatlong-mapdot`,
      {
        address,
        city,
        country,
      },
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return data;
  }

  async findMapdotAddressCityCountry(mapdotId, userLatitude, userLongitude) {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${mapdotId}/addressCityCountry-mapdot`,
      {
        userLatitude,
        userLongitude,
      },
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return data;
  }

  // async adminDeletesMapdot(
  //   mapdotId,
  // ) {
  //   const { data } = await axios
  //     .delete(`${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${mapdotId}/mapdot-delete`,
  //       {},
  //       {
  //         headers: {
  //           Authorization: `${localStorage.jwtToken}`,
  //         },
  //       },
  //     );
  //   return data;
  // }

  async deleteMapdot(id) {
    const { data: mapdots } = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${id}/delete`,
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return mapdots;
  }

  async deleteCommentByAuthor(id) {
    const { data: mapdots } = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${id}/delete-comment`,
      {},
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return mapdots;
  }

  async updateImageMeeting(mapdotId, hasAnImgForMeetings) {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${mapdotId}/edit-has-an-image-meeting`,
      {
        hasAnImgForMeetings,
      },
      {
        headers: {
          Authorization: `${localStorage.jwtToken}`,
        },
      }
    );
    return data;
  }

  async checkDuplicates(venues) {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/check-duplicates`,
      { venues },
      { headers: { Authorization: `${localStorage.jwtToken}` } }
    );
    return data; // { warnings: [{ index, label, matches: [...] }] }
  }

  async bulkImportVenues(venues) {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/bulk-import`,
      { venues },
      { headers: { Authorization: `${localStorage.jwtToken}` } }
    );
    return data;
  }

  async transferVenueOwner(mapdotId, newOwnerId) {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URI}/api/mapdots/${mapdotId}/transfer-owner`,
      { newOwnerId },
      { headers: { Authorization: `${localStorage.jwtToken}` } }
    );
    return data;
  }
}

const mapdotService = new MapdotService();

export default mapdotService;
